import Swiper from "swiper"
export default function instagramApi() {


    jQuery.fn.FCInstagram.accessData = {
        accessToken: "IGAASPEiRjZBYFBZAGE1MWRQRkw3czRnR2ZAkQ2VCLTVVNlJ0YWszcHVOYUVTLTA0WVNuTm53RmpsZAUVSa1FwczdQTnB3SlFwQk5GNS15VHppN3kyY3J1NVhjYzdWX0FZAY281SENyTXdNOElLLTVkQklTZAXBGWTM0WjdCX0FSS3VTdwZDZD"
        // Token
    };

    $('#instafeed').FCInstagram({
        max: 10, // A number between 1 and 25 of photos to show. Default: 9
        autoplay: false, // Set autoplay video: true/false. Default: false
        complete: function () { // A callback function to execute after the display of the photos.
            console.log('completed');

            const instaItems = document.querySelectorAll('#instafeed a')
            const instaWrapper = document.querySelector('#instafeed')

            const htmlSlide = [...instaItems].map(item => {
                return `
                <div  class="swiper-slide">
                        <span style="visibility:hidden">-</span>
                        <div>
                            ${item.outerHTML}    
                            <div class="content">
                            <svg>
                                <use xlink:href="#icon_instagram_white"></use>
                            </svg>
                            <span class="text-caps-2">Ver no instagram</span>
                            </div>
                        </div>
                </div>
                `
            }).join('')

            instaWrapper.innerHTML = `          
            <div class="swiper swiper-acompanhe-nos" style="display: grid; width:100%;">
                <div class="swiper-wrapper">
                ${htmlSlide}
                </div>
            </div>
            `

            const swiperAcompanhe = new Swiper(".swiper-acompanhe-nos", {
                lazy: true,
                slidesPerView: 1.2,
                spaceBetween: 8,
                // centeredSlides:true,
                // centeredSlidesBounds:true,

                breakpoints: {
                    540: {
                        slidesPerView: 2.5,
                    },
                    1024: {
                        slidesPerView: 4,
                    },
                }

                // autoplay:{
                //     delay: 3000
                // }

            });
        }
    });


}